import React from 'react';
import { motion } from 'framer-motion';
export function CienciaSection() {
  return <section id="la-ciencia" aria-label="La ciencia detrás del Código 888" className="relative min-h-[50vh] sm:min-h-[80vh] flex items-center px-4 sm:px-[5%] py-16 sm:py-20 bg-cover bg-center" style={{
    backgroundImage: "url('https://cdn.shopify.com/s/files/1/0981/0781/8286/files/El_Hero_Visual_Fondo_de_red_neuronal.png?v=1775420937&width=1200&crop=center')"
  }} data-id="element-71">
      {/* Overlay */}
      <div className="absolute inset-0" aria-hidden="true" style={{
      background: 'linear-gradient(180deg, #0A0A0B 5%, rgba(10,10,11,0.6) 50%, #0A0A0B 95%)',
      zIndex: 1
    }} data-id="element-72" />
      <div className="absolute inset-0 hidden lg:block" aria-hidden="true" style={{
      background: 'linear-gradient(90deg, #0A0A0B 15%, transparent 60%, #0A0A0B 95%)',
      zIndex: 1
    }} data-id="element-73" />

      {/* Content */}
      <div className="relative max-w-[550px] mx-auto lg:mx-0 text-center lg:text-left" style={{
      zIndex: 2
    }} data-id="element-74">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.1
      }} transition={{
        duration: 0.8
      }} style={{
        opacity: 1
      }} data-id="element-75">
          <span className="inline-block text-gold text-[10px] md:text-xs font-extrabold tracking-[3px] uppercase mb-4" data-id="element-76">
            CIENCIA APLICADA
          </span>

          <h2 className="font-serif text-4xl md:text-5xl font-black mb-6 leading-tight" data-id="element-77">
            Intervención <br data-id="element-78" />
            <span className="text-gold" data-id="element-79">Bio-Digital</span>
          </h2>

          <p className="text-lg opacity-95 leading-relaxed mb-8" data-id="element-80">
            El Código 888 no es una simple meditación. Es una señal acústica
            diseñada para reprogramar tu{' '}
            <strong className="text-white font-bold" data-id="element-81">
              Sistema de Activación Reticular (SAR)
            </strong>
            , eliminando físicamente los surcos neuronales de la escasez.
          </p>

          <div className="flex flex-wrap gap-3 justify-center lg:justify-start mt-8" role="list" aria-label="Tecnologías aplicadas" data-id="element-82">
            {['Neuro-Plasticidad', 'Ondas Theta', 'Frecuencias Solfeggio'].map((pill, index) => <motion.span key={index} role="listitem" initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true,
            amount: 0.1
          }} transition={{
            duration: 0.4,
            delay: 0.2 + index * 0.1
          }} className="border border-gold text-gold px-4 py-1.5 text-[10px] rounded-full uppercase font-extrabold tracking-wider" style={{
            opacity: 1
          }} data-id="element-83">
                  {pill}
                </motion.span>)}
          </div>
        </motion.div>
      </div>
    </section>;
}